import { useDispatch, useSelector } from 'react-redux'
import { selectors } from 'shared/store'
import { actions } from 'shared/store'
import { LoadingStatus } from 'shared/types'

export const useGetCountries = () => {
  const dispatch = useDispatch()
  const countries = useSelector(selectors.settings.getCountries)
  const { settings } = useSelector(selectors.settings.getLoadingState)

  if (!countries && settings === LoadingStatus.Idle)
    dispatch(actions.settings.getCountries())

  return countries
}
